import { useIsSplitEnabled, useSplitEnabled } from '@buffer-mono/features'

export const BOARD_VIEW_SPLIT = 'geid-publish-board-view'

/** Gates the Board view trigger itself — the toggle option, not just its content. */
export function useBoardViewEnabled(): boolean {
  return useIsSplitEnabled(BOARD_VIEW_SPLIT)
}

/**
 * Ready-aware variant for the route guard: redirecting off `/schedule/board`
 * before the Split SDK is ready would bounce a flag-on user back to List on
 * every deep link or refresh, since `isEnabled` defaults to `false` pre-ready.
 */
export function useBoardViewReady(): { isEnabled: boolean; isReady: boolean } {
  const { isEnabled, isReady, isReadyFromCache, isTimedout } =
    useSplitEnabled(BOARD_VIEW_SPLIT)

  // A cache-based "ready" can be stale right after this split's targeting
  // changes (e.g. widening to a new audience) — trusting a lingering cached
  // "off" would bounce the user to List before the SDK-confirmed value ever
  // arrives, and the redirect itself isn't undone once the real value lands.
  // Wait for a network-confirmed answer, or a timeout so a genuinely broken
  // SDK doesn't loader-lock the route forever.
  const isConfirmed = isTimedout || !isReadyFromCache

  return { isEnabled, isReady: isReady && isConfirmed }
}
